/** US NANP: optional empty, else 10 digits after optional +1 / formatting. */

const US_DIGITS = /^[2-9]\d{2}[2-9]\d{6}$/

export function normalizeUsPhoneDigits(input: string): string {
  const d = input.replace(/\D/g, '')
  if (d.length === 11 && d.startsWith('1')) return d.slice(1)
  return d
}

/** Empty or whitespace-only counts as valid (optional field). */
export function isValidUsPhone(input: string): boolean {
  if (!input.trim()) return true
  return US_DIGITS.test(normalizeUsPhoneDigits(input))
}

export function formatUsPhoneE164(input: string): string {
  const d = normalizeUsPhoneDigits(input)
  return `+1${d}`
}
